import React, { useEffect } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import styled from 'styled-components';

import EmptyState from '../EmptyState';
import StyledContainer from '../../../ui-library/styled/StyledContainer';
import useScroll from '../../../utils/useScroll';
import { Space } from '../../../ui-library/space';
import FabricSummary from './FabricSummary';
import useFabricTitle from './useFabricTitle';
import Blurb from './Blurb';

const StyledProductSummaryDiv = styled.div`
  padding-left: 16px;
  padding-right: 16px;
`;
const FabricDetailPage = ({ product }) => {
  const { scrollToTop } = useScroll();

  useFabricTitle(product);

  useEffect(() => {
    scrollToTop();
  }, []);

  if (!product || !product._id) {
    return <EmptyState />;
  }
  return (
    <StyledContainer>
      <Row>
        <Col lg={8}>
          <div
            style={{
              padding: '0 32px 32px 0',
              width: '100%',
              objectFit: 'cover',
              overflow: 'hidden',
            }}
          >
            <Image src={product.imageURL} />
            <Blurb product={product} />
          </div>
        </Col>
        <Col lg={4}>
          <StyledProductSummaryDiv>
            <FabricSummary product={product} />
          </StyledProductSummaryDiv>
        </Col>
      </Row>
      <Row>
        <Col>
          <Space size={16} />
        </Col>
      </Row>
    </StyledContainer>
  );
};

export default FabricDetailPage;
